<style>
  p {
    font-size: 0.9em;
    margin: 0.3em 0.2em 0.3em 0.2em; /* top | right | bottom | left */
    padding: 0.3em;
    text-align: left;
    flex: 0 0 auto;
  }
  .captions {
    display: flex;
    flex-flow: column;
    flex: 0 0 auto;
  }
  .columns {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .values {
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
  }
</style>

<script>
  import { onMount } from 'svelte';
  import auth from "../auth";
  import { 
    auth_logged_in, auth_user, 
    lang, 
    prof_edit, prof_edit_mode
  } from "../store";
  import util from '../util';
  import ProfileRecord from './ProfileRecord.svelte';
  
  export let item_id;
  item_id = item_id;
  
  const profile_items = [
    'full_name',
    'email',
    'phone',
    'comp_name',
    'mon_freq',
  ];
  
  onMount(() => {
    $prof_edit_mode = false;
    $prof_edit.input_selected_once = false;
    $prof_edit.input_valid = false;
    $prof_edit.result = {};
    $prof_edit.validation = {};
  });
</script>

{#if $auth_logged_in && $auth_user}
  <div class='columns'>
    <div class='captions'>
    {#each profile_items as item_type}
      <p>{util.caption($lang,'prof_panel',item_type)}</p>
    {/each}
    </div>
    <div class='values'>
    {#key $auth_user || $prof_edit_mode}
      {#each profile_items as item_type}
        <ProfileRecord {item_type}/>
      {/each}
    {/key}
    </div>
  </div>
{:else}
  <p>{util.caption($lang,'prof_panel','logged_out')}</p>
{/if}
